import type { PropsWithChildren } from "react"

import styles from "./Blockquote.module.css"

export function Blockquote(props: PropsWithChildren) {
  return <blockquote {...props} className={styles.root} />
}
